import * as React from 'react';

import { Control } from 'react-redux-form';

// Models
import { CustomerSearchViewModel, CustomerViewModel } from '@models/Customer';
import { PageViewModel } from '@models/common.models';
import { Customer } from '../../..';

// Components
import { TypeAheadComponent, ModalProps } from '@common/components';
import { Option } from 'react-select';

export interface CustomerPickerComponentProperties {
  readonly customer?: CustomerViewModel;
  readonly placeholder?: string;

  readonly clearCustomer: () => void;
  readonly loadCustomer: (id: number) => void;
  readonly lookupCustomer: (query: string, id?: number) => Promise<PageViewModel<CustomerViewModel>>;
  readonly onCustomerSelect: (model: string, value: number) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
}

export class CustomerPickerComponent extends React.Component<CustomerPickerComponentProperties> {
  public render(): JSX.Element {
    return (
      <div className="row">
        <div className="col-md-9 mb-10">
          <Control.text
            className="form-control"
            changeAction={this.props.onCustomerSelect}
            model=".customerId"
            component={(props: { value: string; onChange: Function }) => {
              return (
                <TypeAheadComponent
                  {...props}
                  getSuggestions={this.props.lookupCustomer}
                  labelKey="name"
                  onChange={props.onChange}
                  placeholder={this.props.placeholder}
                  renderValue={this.renderCustomerSearch}
                  valueKey="id"
                  value={props.value}
                />
              );
            }}
          />
          <Control.text className="txt-hidden" model=".customerId" />
        </div>
        <div className="col-md-3 text-center">{this.renderAddEditCustomer()}</div>
      </div>
    );
  }

  private loadCustomer(id: number): void {
    this.props.toggleModal();
    this.props.loadCustomer(id);
  }

  private renderAddEditCustomer(): JSX.Element {
    if (this.props.customer && this.props.customer.name) {
      return (
        <div className="row">
          <div className="col-md-1 mt-15">
            <i className="fa fa-times" onClick={this.props.clearCustomer} />
          </div>
          <div className="col-md-2 mt-5">
            <button className="btn btn-primary" type="button" onClick={this.showCustomerModal}>
              Edit Customer
            </button>
          </div>
        </div>
      );
    }
    return (
      <button className="btn btn-primary mt-5" type="button" onClick={this.showCustomerModal}>
        Add New Customer
      </button>
    );
  }

  private renderCustomerSearch(suggestion: Option<CustomerSearchViewModel>): JSX.Element {
    return (
      <div>
        <div>Name: {suggestion.name ? suggestion.name : '—'}</div>
        <div>Phone #: {suggestion.phone ? suggestion.phone : '—'}</div>
      </div>
    );
  }

  private showCustomerModal = (): void => {
    if (this.props.customer) {
      this.props.toggleModal({
        childProps: { entityId: this.props.customer.id },
        component: Customer,
        saveCallback: this.loadCustomer.bind(this),
        title: 'Edit Buyer/Owner Customer'
      });
    } else {
      this.props.toggleModal({
        component: Customer,
        saveCallback: this.loadCustomer.bind(this),
        title: 'Add New Buyer/Owner Customer'
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/customer/_components/customer-picker/_components/customer-picker.component.tsx